import React from "react";
import { motion } from "framer-motion";
import { Zap, IndianRupee, MessageSquare, Crown, Globe2, ShieldCheck } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const ICONS = [Zap, IndianRupee, MessageSquare, Crown, Globe2, ShieldCheck];

export default function Trust() {
  const { t } = useLang();
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">{t.trust.eyebrow}</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 text-slate-950">{t.trust.title}</h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.trust.points.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05, duration: 0.5 }}
                className="rounded-2xl border border-slate-200 p-6 hover:border-slate-300 hover:bg-slate-50 transition-all"
                data-testid={`trust-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-display text-lg font-bold mt-5 text-slate-950">{p.t}</h3>
                <p className="text-slate-600 mt-1.5 text-sm leading-relaxed">{p.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
